import { Component, EventEmitter, Input, Output } from '@angular/core';
import { closeIcon } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'g99-lib-maintainence-banner',
  templateUrl: './maintainence-banner.component.html',
  styleUrl: './maintainence-banner.component.scss',
  standalone: false,
})
export class MaintainenceBannerComponent {
  @Input() public shouldShowBanner = false;
  @Input() public title = 'System Maintenance';
  @Input() public description = '';
  @Output() public bannerClosed = new EventEmitter<void>();

  protected closeIcon = closeIcon;

  protected onCloseClick(): void {
    this.shouldShowBanner = false;
    this.bannerClosed.emit();
  }
}
